import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";

/**
 * Footer displaying the total filtered user count.
 * @param {object} props
 * @param {number} props.count - Total number of filtered users
 * @returns {React.ReactElement}
 */
function UsersFooter({ count, label = "Total Utilisateurs" }) {
    const boxBg = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
    const labelColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    const countColor = useColorModeValue("secondaryGray.900", "white");
    return (
        <Box mt="16px" p="16px" borderRadius="14px" bg={boxBg}>
            <Text color={labelColor} textTransform="uppercase" fontSize="0.7rem" fontWeight="600" letterSpacing="1px" mb="4px">
                {label}
            </Text>
            <Text color={countColor} fontWeight="800" fontSize="1.8rem" lineHeight="1">{count}</Text>
        </Box>
    );
}

export default UsersFooter;
